import { n_book_lessons, s_lessons_schedule } from '../modules/i18n/strings/auto/wording'
import useTranslation from '../modules/i18n/useTranslation'
import { ETIQUETTE_1, ETIQUETTE_2, ETIQUETTE_3, ETIQUETTE_4 } from '../modules/images'

interface EtiquetteCardPropsType {
  imgUrl: string
  title: string
  subtitle: React.ReactNode
}

export const EtiquetteCard = ({ imgUrl, title, subtitle }: EtiquetteCardPropsType) => {
  return (
    <div className="flex flex-col">
      <img src={imgUrl} width={123} height={95} alt="no image" />
      <div className="mt-[12px]">
        <div className="Body2-14Bd">{title}</div>
        <div className="Body2-14Md mt-[6px] text-gray-700">{subtitle}</div>
      </div>
    </div>
  )
}
const Etiquette = () => {
  const { t } = useTranslation()

  const list = [
    {
      imgUrl: ETIQUETTE_1,
      title: t(s_lessons_schedule.rules.set_up),
      subtitle: (
        <>
          {t(s_lessons_schedule.rules.do_not_drive)}
          <br /> {t(s_lessons_schedule.rules.no_drinking)}
        </>
      ),
    },
    {
      imgUrl: ETIQUETTE_2,
      title: t(s_lessons_schedule.rules.punctual),
      subtitle: (
        <>
          {t(s_lessons_schedule.rules.keep_schdules)}
          <br /> {t(s_lessons_schedule.rules.no_external_request)}
        </>
      ),
    },
    {
      imgUrl: ETIQUETTE_3,
      title: t(s_lessons_schedule.rules.with_respect),
      subtitle: (
        <>
          {t(s_lessons_schedule.rules.no_photos)}
          <br /> {t(s_lessons_schedule.rules.no_discriminatory_remarks)}
        </>
      ),
    },
    {
      imgUrl: ETIQUETTE_4,
      title: t(s_lessons_schedule.rules.focus_on_learning),
      subtitle: (
        <>
          {t(s_lessons_schedule.rules.avoid_unrelated)}
          <br /> {t(s_lessons_schedule.rules.turn_on_video)}
        </>
      ),
    },
  ]
  return (
    <div className="w-full px-[32px] sm:bg-gray-50 sm:pt-[32px] sm:pb-[102px]">
      <div className="mx-auto max-w-[1000px]">
        <div className="hidden sm:flex">
          <div className="Body1-16Bd text-center">{t(n_book_lessons.rules.check_rules)}</div>
          <div className="Body2-14Md ml-[4px] text-center text-gray-500">
            {t(n_book_lessons.rules.follow_guidelines)}
          </div>
        </div>
        <div className="Body1-16Bd sm:hidden">{t(n_book_lessons.rules.check_rules)}</div>
        <div className="mt-[40px] grid grid-cols-1 gap-[36px] sm:grid-cols-4 sm:gap-[30px]">
          {list.map((item, i) => {
            return <EtiquetteCard key={`item-${i}`} title={item.title} subtitle={item.subtitle} imgUrl={item.imgUrl} />
          })}
        </div>
      </div>
    </div>
  )
}
export default Etiquette
